import React, { Suspense, lazy } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { Outlet } from "react-router-dom";
import Navbar from "../../scenes/navbar";
import RouteSkeleton from "../../components/RouteSkeleton";

const Sidebar = lazy(() => import("../../scenes/sidebar"));

const AppLayout = ({ children }) => {
  const isNonMobileScreens = useMediaQuery("(min-width:1000px)");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden" }}>
      <Navbar />
      <Box display="flex" width="100%" sx={{ flex: 1, overflow: "hidden" }}>
        {isNonMobileScreens && (
          <Box flexBasis="20%" sx={{ height: "100%" }}>
            <Suspense fallback={<div>Loading Sidebar...</div>}>
              <Sidebar />
            </Suspense>
          </Box>
        )}
        <Box flex={1} sx={{ overflow: "hidden", height: "100%", minWidth: 0 }}>
          <Suspense fallback={<RouteSkeleton embedded />}>
            {children ?? <Outlet />}
          </Suspense>
        </Box>
      </Box>
    </Box>
  );
};

export default AppLayout;
